import { defineMessage, defineMessages } from 'react-intl'

export const healthPlanPaymentMessages = defineMessages({
  creditCardRequirementDisclaimer: {
    defaultMessage:
      'You may have co-pays, co-insurances, or deductibles attached to future sessions. <link>Learn more</link>',
    description:
      'Body text underneath title in cost sharing payment forms. Explains why Lyra needs your credit/debit card information for cost sharing',
  },
  creditCardRequirementDisclaimerSelfPayExtension: {
    defaultMessage:
      'You may have self-pay, no-show, or late cancellation charges attached to future sessions. You’ll only be charged after each session, and we’ll always notify you by email beforehand.',
    description:
      'Body text underneath title in cost sharing payment forms for self-pay extension. Explains why Lyra needs your credit/debit card information for cost sharing',
  },
  creditCardRequirementHPISpecificDisclaimer: {
    defaultMessage:
      'We’ll need this for any out-of-pocket costs, or to collect payments for appointments you miss or cancel within 24 hours. <link>Learn more</link>.',
    description:
      'Body text underneath title in cost sharing payment forms. Explains why Lyra needs your credit/debit card information for cost sharing specifically for HPI care',
  },
  emailBeforeChargeDisclaimer: {
    defaultMessage: 'You’ll only be charged after each session, and we’ll always notify you by email beforehand.',
    description: 'Payment form message informing user they will be emailed before charged',
  },
  lateCancellationOrNoShowDisclaimer: {
    defaultMessage: 'Add a credit or debit card to cover any late-cancellation or no-show payments',
    description:
      'Body text underneath title in infraction payment form. Explains why Lyra needs your credit/debit card information for infractions',
  },
  infractionCardEmptyDescription: {
    defaultMessage:
      "When you're booked with a provider, a valid form of payment is needed to cover late-cancellations and no-show payments.",
    description: 'Text informing the user what payment methods are for',
  },
  infractionCardEmptyDescriptionSelfPay: {
    defaultMessage: 'Once you book a session, provide a payment method for self-pay, late cancellations, or no shows.',
    description: 'Text informing the user what payment methods are for (self-pay extension)',
  },
  healthPlanAddedSuccessMessage: {
    defaultMessage: 'Health plan successfully added',
    description: 'Toast message displayed when a health plan is successfully added',
  },
})

export const defaultHealthPlanDisplayName = defineMessage({
  defaultMessage: 'EPO/PPO plan',
  description: 'Text to denote a default health plan name',
})

export const notEnrolledHealthPlanOption = defineMessage({
  defaultMessage:
    '{searchFor, select, self {I’m not} other {This child isn’t}} enrolled in a {hasCustomerName, select, true {health plan through {customerName}} other {health plan}}',
  description: 'Option text denoting that the user is not enrolled in a health plan',
})
